import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import FrameworkUtils from 'utils/framework';
import Actions from 'Actions';
import GuestBookingMessagingEN from 'components/GlobalModals/SignInWithMessagingModal/GuestBookingMessaging/locales/GuestBookingMessaging_en_US';
import GuestBookingMessagingFR from 'components/GlobalModals/SignInWithMessagingModal/GuestBookingMessaging/locales/GuestBookingMessaging_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(GuestBookingMessagingEN, GuestBookingMessagingFR);

const localization = createStructuredSelector({
    createAccountBookingMessage: getTextFromResource(getText, 'createAccountBookingMessage'),
    bankYourBeautyPointsFree: getTextFromResource(getText, 'bankYourBeautyPointsFree', ['{0}']),
    freeBirthdayGift: getTextFromResource(getText, 'freeBirthdayGift'),
    seasonalSavingsEvents: getTextFromResource(getText, 'seasonalSavingsEvents'),
    freeShipping: getTextFromResource(getText, 'freeShipping'),
    createAccountButton: getTextFromResource(getText, 'createAccountButton'),
    bookingAsAGuestButton: getTextFromResource(getText, 'bookingAsAGuestButton')
});

const fields = createStructuredSelector({
    localization
});

const functions = {
    showSignInWithMessagingModal: Actions.showSignInWithMessagingModal,
    showRegisterModal: Actions.showRegisterModal
};

const withGuestBookingMessagingProps = wrapHOC(connect(fields, functions));

export {
    fields, functions, withGuestBookingMessagingProps
};
